import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface PanFormReportSliceStateType {
  items: any[];
  totalItems: number;
  isTableLoading: boolean;
  page: number;
  rowsPerPage: number;
  searchValue: string;
  filterBy: {
    fieldName: string;
    value: string[];
  }[];
  dateFilter: {
    start_date: string | null | any;
    end_date: string | null | any;
  };
  orderByValue: number;
}

const initialState: PanFormReportSliceStateType = {
  items: [],
  totalItems: 0,
  isTableLoading: false,
  page: 1,
  rowsPerPage: 10,
  searchValue: "",
  filterBy: [
    { fieldName: "status", value: [] },
    { fieldName: "applicationType", value: [] },
    { fieldName: "distributorCode", value: [] },
  ],
  dateFilter: {
    start_date: "",
    end_date: "",
  },
  orderByValue: -1,
};

const PanFormReportSlice: any = createSlice({
  name: "panFormReport",
  initialState,
  reducers: {
    resetState: () => initialState,
    setItems: (state, action: PayloadAction<any[]>) => {
      state.items = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.page = 1;
      document.getElementById("scroll-top")?.scrollTo(0, 0);
    },
    setSearchValue: (state, action: PayloadAction<string>) => {
      state.searchValue = action.payload;
      state.page = 1;
    },
    setTotalItems: (state, action: PayloadAction<number>) => {
      state.totalItems = action.payload;
    },
    setIsTableLoading: (state, action: PayloadAction<boolean>) => {
      state.isTableLoading = action.payload;
    },
    setFilterBy: (
      state,
      action: PayloadAction<{ fieldName: string; value: string[] }[]>
    ) => {
      state.filterBy = action.payload;
      state.page = 1;
    },
    setDateFilter: (
      state,
      action: PayloadAction<{ start_date: string; end_date: string }>
    ) => {
      state.dateFilter = action.payload;
      state.page = 1;
    },
    setOrderByValue: (state, action: PayloadAction<number>) => {
      state.orderByValue = action.payload;
    },
  },
});

export const {
  resetState,
  setItems,
  setPage,
  setRowsPerPage,
  setSearchValue,
  setTotalItems,
  setIsTableLoading,
  setFilterBy,
  setDateFilter,
  setOrderByValue,
} = PanFormReportSlice.actions;
export default PanFormReportSlice.reducer;
